import ReviewFormSFC from "./ReviewForm.vue";
export const ReviewForm = ReviewFormSFC;
